'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _Constants = require('@vezeeta/enterprise-utils/lib/Constants');

var _webSso = require('@vezeeta/web-sso');

var _appointments = require('../actions/appointments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getReservationCount),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getAppointmentInvoice),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(fetchAppointments),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(fetchAppointmentsUpdates),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(upsertAppointment),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(upsertEditAppointment),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(addAppointment),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(markAsNoShow),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(markAsInsured),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(checkInAppointment),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(completeAppointment),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(cancelAppointment),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(addPrescription),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(getPatientNationalId),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(getPatientInsuranceCard),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(uploadNationalIdImg),
    _marked17 = /*#__PURE__*/_regenerator2.default.mark(getPatientApprovalLetter),
    _marked18 = /*#__PURE__*/_regenerator2.default.mark(uploadApprovalLetter),
    _marked19 = /*#__PURE__*/_regenerator2.default.mark(sagaAddVitals),
    _marked20 = /*#__PURE__*/_regenerator2.default.mark(sagaUpdateVitals),
    _marked21 = /*#__PURE__*/_regenerator2.default.mark(appointmentsSaga);

function getReservationCount(payload) {
  var accountToken, culture, Headers, getReservationCountApi, body, response;
  return _regenerator2.default.wrap(function getReservationCount$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }, {
            key: 'language',
            value: culture
          }];
          getReservationCountApi = new _webUtils.API();
          body = payload.payload;
          _context.next = 7;
          return getReservationCountApi.post(_webUtils.Urls.countReservationsInRange2, body, Headers);

        case 7:
          response = _context.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context.next = 13;
            break;
          }

          _context.next = 11;
          return (0, _effects.put)((0, _appointments.getReservationCountSuccess)(response.data));

        case 11:
          _context.next = 15;
          break;

        case 13:
          _context.next = 15;
          return (0, _effects.put)((0, _appointments.getReservationCountFailed)(response));

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getAppointmentInvoice(payLoad) {
  var accountToken, Headers, reservationKey, getNationalIdApi, getNationalIdApiResponse;
  return _regenerator2.default.wrap(function getAppointmentInvoice$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          reservationKey = payLoad.payload.reservationKey;
          getNationalIdApi = new _webUtils.API();
          _context2.next = 6;
          return getNationalIdApi.get('' + _webUtils.Urls.getAppointmentInvoice + reservationKey, Headers);

        case 6:
          getNationalIdApiResponse = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(getNationalIdApiResponse.status)) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)((0, _appointments.getAppointmentInvoiceSuccess)(getNationalIdApiResponse.data));

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.next = 14;
          return (0, _effects.put)((0, _appointments.getAppointmentInvoiceFailed)(getNationalIdApiResponse.response));

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function fetchAppointments(payload) {
  var api, authToken, culture, header, accountKeysQueryString, convertDateAndTimeToIsoDate, response, appointments;
  return _regenerator2.default.wrap(function fetchAppointments$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          // pageNumber
          // pageSize
          // branchKey
          // patientKey
          // accountKeys
          // vezeetaPatientsOnly
          // fromDate
          // toDate
          // includeSummary
          // statuses

          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          accountKeysQueryString = '';
          // m/d/yyyy to yyyy-10-01

          convertDateAndTimeToIsoDate = function convertDateAndTimeToIsoDate(date) {
            var dateSplittedList = date.split('/');
            var month = dateSplittedList[0];
            var day = dateSplittedList[1];
            if (month && month.length !== 2) {
              month = '0' + month;
            }
            if (day && day.length !== 2) {
              day = '0' + day;
            }
            // YYYY-MM-DD
            var reformedDate = dateSplittedList[2] + '-' + month + '-' + day;
            return '' + reformedDate;
          };

          if (payload) {
            accountKeysQueryString = 'pageNumber=' + payload.pageNumber + '&pageSize=' + (payload.pageSize ? payload.pageSize : _Constants.PAGE_SIZE) + '&includeSummary=true&';

            if (payload.branchKeys && payload.branchKeys.length) {
              payload.branchKeys.forEach(function (branchKey) {
                accountKeysQueryString = accountKeysQueryString + 'branchKeys=' + branchKey + '&';
              });
            }
            if (payload.patientKey) {
              accountKeysQueryString = accountKeysQueryString + 'patientKey=' + payload.patientKey + '&';
            }
            if (payload.doctors && payload.doctors.length) {
              payload.doctors.forEach(function (doctor) {
                accountKeysQueryString = accountKeysQueryString + 'accountKeys=' + doctor.AccountKey + '&';
              });
            }
            if (payload.statuses && payload.statuses.length) {
              payload.statuses.forEach(function (status) {
                accountKeysQueryString = accountKeysQueryString + 'statuses=' + status + '&';
              });
            }
            accountKeysQueryString = accountKeysQueryString + 'vezeetaPatientsOnly=false&fromDate=' + convertDateAndTimeToIsoDate(payload.startDate) + ' 00:00:00&toDate=' + convertDateAndTimeToIsoDate(payload.endDate) + ' 23:59:59&';
          }

          _context3.next = 9;
          return api.get(_webUtils.Urls.fetchAppointmentsUrl2 + '?' + accountKeysQueryString, header);

        case 9:
          response = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context3.next = 17;
            break;
          }

          appointments = [];


          response.data.Reservations.forEach(function (appointment) {
            var roomName = payload.roomsNames.get(appointment.Room.RoomKey);
            var doctorName = payload.doctorsNames.get(appointment.Doctor.DoctorKey);

            appointments.push(_extends({}, appointment, {
              roomName: roomName,
              doctorName: doctorName
            }));
          });

          _context3.next = 15;
          return (0, _effects.put)((0, _appointments.fetchAppointmentsSuccess)(appointments, response.data.Summary, payload.pushToCurrent));

        case 15:
          _context3.next = 19;
          break;

        case 17:
          _context3.next = 19;
          return (0, _effects.put)((0, _appointments.fetchAppointmentsFail)());

        case 19:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function fetchAppointmentsUpdates(payload) {
  var api, body, response, appointments;
  return _regenerator2.default.wrap(function fetchAppointmentsUpdates$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          api = new _webSso.AuthApi();
          body = {
            AccountRooms: payload.doctors.map(function (doctor) {
              return {
                AccountKey: doctor.AccountKey,
                RoomKey: doctor.RoomKey
              };
            }),
            PatientKey: payload.patientKey,
            From: payload.startDate,
            To: payload.endDate,
            Page: !payload.newAppointment ? payload.pageNumber : null,
            PageSize: payload.pageSize
          };
          _context4.next = 4;
          return api.post(_webUtils.Urls.fetchAppointmentsUrl, body);

        case 4:
          response = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context4.next = 12;
            break;
          }

          appointments = [];


          response.data.forEach(function (appointment) {
            var roomName = payload.roomsNames.get(appointment.RoomKey);
            var doctorName = payload.doctorsNames.get(appointment.AccountKey);

            appointments.push(_extends({}, appointment, {
              roomName: roomName,
              doctorName: doctorName
            }));
          });
          _context4.next = 10;
          return (0, _effects.put)((0, _appointments.fetchAppointmentsUpdatesSuccess)(appointments, payload.pushToCurrent));

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.next = 14;
          return (0, _effects.put)((0, _appointments.fetchAppointmentsUpdatesFail)());

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function upsertAppointment(payload) {
  var addAppointmentApi, addAppointmentBody, addAppointmentResponse;
  return _regenerator2.default.wrap(function upsertAppointment$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          addAppointmentApi = new _webSso.AuthApi();
          addAppointmentBody = payload.payload;
          _context5.next = 4;
          return addAppointmentApi.post(_webUtils.Urls.createAppointmentUrl, addAppointmentBody);

        case 4:
          addAppointmentResponse = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(addAppointmentResponse.status)) {
            _context5.next = 10;
            break;
          }

          _context5.next = 8;
          return (0, _effects.put)((0, _appointments.addAppointmentSuccess)([_extends({}, addAppointmentResponse && addAppointmentResponse.response && addAppointmentResponse.response.Data && addAppointmentResponse.response.Data.ReturnObject && addAppointmentResponse.response.Data.ReturnObject[0], payload.payload && payload.payload[0], {
            BranchKey: addAppointmentBody[0].BranchKey
          })]));

        case 8:
          _context5.next = 12;
          break;

        case 10:
          _context5.next = 12;
          return (0, _effects.put)((0, _appointments.addAppointmentFailed)());

        case 12:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function upsertEditAppointment(payload) {
  var upsertEditAppointmentApi, editAppointmentBody, editAppointmentResponse;
  return _regenerator2.default.wrap(function upsertEditAppointment$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          upsertEditAppointmentApi = new _webSso.AuthApi();
          editAppointmentBody = payload.payload;
          _context6.next = 4;
          return upsertEditAppointmentApi.post(_webUtils.Urls.editAppointmentUrl, editAppointmentBody);

        case 4:
          editAppointmentResponse = _context6.sent;

          if (!_webUtils.STATUS.isSuccess(editAppointmentResponse.status)) {
            _context6.next = 10;
            break;
          }

          _context6.next = 8;
          return (0, _effects.put)((0, _appointments.submitEditAppointmentSuccess)(editAppointmentResponse.data));

        case 8:
          _context6.next = 12;
          break;

        case 10:
          _context6.next = 12;
          return (0, _effects.put)((0, _appointments.submitEditAppointmentFailed)());

        case 12:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function addAppointment(payload) {
  var addAppointmentBody, addAppointmentApi, addAppointmentResponse;
  return _regenerator2.default.wrap(function addAppointment$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          addAppointmentBody = void 0;


          if (payload.appointment && payload.appointment.isAppointementReschedule) {
            addAppointmentBody = [{
              ReservationSource: 'DoctorsApp',
              ActionMaker: 'Doctor',
              SendReminderMessage: 0,
              PatientKey: payload.appointment.PatientKey,
              AccountKey: payload.appointment.doctor,
              RoomKey: payload.appointment.room,
              ReservationKey: payload.appointment.ReservationKey,
              ReservationDate: payload.appointment.date + ' ' + payload.appointment.time,
              CountrySpecialityKey: payload.appointment.DoctorSpecialtyKey
            }];
          } else {
            addAppointmentBody = [{
              ReservationSource: 'DoctorsApp',
              ActionMaker: 'Doctor',
              ReservationDate: payload.appointment.date + ' ' + payload.appointment.time,
              InsuranceKey: '',
              Notes: payload.appointment.notes,
              VisitType: payload.appointment.type,
              SendReminderMessage: 0,
              AccountKey: payload.appointment.doctor,
              RoomKey: payload.appointment.room,
              PatientKey: payload.patient.key
              // CountrySpecialityKey: payload.appointment.DoctorSpecialtyKey,
            }];
          }

          addAppointmentApi = new _webSso.AuthApi();
          _context7.next = 5;
          return addAppointmentApi.post(_webUtils.Urls.createAppointmentUrl, addAppointmentBody);

        case 5:
          addAppointmentResponse = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(addAppointmentResponse.status)) {
            _context7.next = 11;
            break;
          }

          _context7.next = 9;
          return (0, _effects.put)((0, _appointments.createAppointmentSuccess)());

        case 9:
          _context7.next = 13;
          break;

        case 11:
          _context7.next = 13;
          return (0, _effects.put)((0, _appointments.createAppointmentFail)());

        case 13:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function markAsNoShow(payload) {
  var appointmentKey, accountKey, roomKey, isNoShow, sendSMS, api, body, url, response;
  return _regenerator2.default.wrap(function markAsNoShow$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          appointmentKey = payload.appointmentKey, accountKey = payload.accountKey, roomKey = payload.roomKey, isNoShow = payload.isNoShow, sendSMS = payload.sendSMS;
          api = new _webSso.AuthApi();
          body = [{
            ActionMaker: 'Doctor',
            AccountKey: accountKey,
            RoomKey: roomKey,
            ReservationKey: appointmentKey,
            SendMessage: sendSMS
          }];
          url = !isNoShow ? _webUtils.Urls.markAppointmentAsNoShow : _webUtils.Urls.undoAppointmentNoShow;
          _context8.next = 6;
          return api.post(url, body);

        case 6:
          response = _context8.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context8.next = 12;
            break;
          }

          _context8.next = 10;
          return (0, _effects.put)((0, _appointments.markAsNoShowSuccess)(appointmentKey, isNoShow));

        case 10:
          _context8.next = 14;
          break;

        case 12:
          _context8.next = 14;
          return (0, _effects.put)((0, _appointments.markAsNoShowFail)(appointmentKey));

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function markAsInsured(payload) {
  var appointmentKey, accountKey, roomKey, isInsured, api, url, body, response;
  return _regenerator2.default.wrap(function markAsInsured$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          appointmentKey = payload.appointmentKey, accountKey = payload.accountKey, roomKey = payload.roomKey, isInsured = payload.isInsured;
          api = new _webSso.AuthApi();
          url = _webUtils.Urls.updateReservationsInsurance;
          body = [{
            ActionMaker: 'Doctor',
            AccountKey: accountKey,
            RoomKey: roomKey,
            ReservationKey: appointmentKey,
            IsInsured: isInsured
          }];
          _context9.next = 6;
          return api.post(url, body);

        case 6:
          response = _context9.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context9.next = 12;
            break;
          }

          _context9.next = 10;
          return (0, _effects.put)((0, _appointments.markAsInsuredSuccess)(appointmentKey, isInsured));

        case 10:
          _context9.next = 14;
          break;

        case 12:
          _context9.next = 14;
          return (0, _effects.put)((0, _appointments.markAsInsuredFail)(appointmentKey));

        case 14:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function checkInAppointment(payload) {
  var appointmentKey, accountKey, roomKey, isCheckedIn, api, body, url, response;
  return _regenerator2.default.wrap(function checkInAppointment$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          appointmentKey = payload.appointmentKey, accountKey = payload.accountKey, roomKey = payload.roomKey, isCheckedIn = payload.isCheckedIn;
          api = new _webSso.AuthApi();
          body = [{
            ActionMaker: 'Doctor',
            AccountKey: accountKey,
            RoomKey: roomKey,
            ReservationKey: appointmentKey,
            UpdateReservationStatus: isCheckedIn ? 'Pending' : 'PatientCheckedIn'
          }];
          url = _webUtils.Urls.checkInAppointment;
          _context10.next = 6;
          return api.post(url, body);

        case 6:
          response = _context10.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context10.next = 12;
            break;
          }

          _context10.next = 10;
          return (0, _effects.put)((0, _appointments.checkInSuccess)(appointmentKey, isCheckedIn));

        case 10:
          _context10.next = 14;
          break;

        case 12:
          _context10.next = 14;
          return (0, _effects.put)((0, _appointments.checkInFail)(appointmentKey));

        case 14:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function completeAppointment(payload) {
  var appointmentKey, accountKey, roomKey, isCompelete, api, setNewStatus, body, url, response;
  return _regenerator2.default.wrap(function completeAppointment$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          appointmentKey = payload.appointmentKey, accountKey = payload.accountKey, roomKey = payload.roomKey, isCompelete = payload.isCompelete;
          api = new _webSso.AuthApi();

          setNewStatus = function setNewStatus() {
            if (!isCompelete) return 'Completed';
            return 'PatientCheckedIn';
          };

          body = [{
            ActionMaker: 'Doctor',
            AccountKey: accountKey,
            RoomKey: roomKey,
            ReservationKey: appointmentKey,
            UpdateReservationStatus: setNewStatus()
          }];
          url = _webUtils.Urls.checkInAppointment;
          _context11.next = 7;
          return api.post(url, body);

        case 7:
          response = _context11.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context11.next = 13;
            break;
          }

          _context11.next = 11;
          return (0, _effects.put)((0, _appointments.completeSuccess)(appointmentKey, isCompelete));

        case 11:
          _context11.next = 15;
          break;

        case 13:
          _context11.next = 15;
          return (0, _effects.put)((0, _appointments.completeFail)(appointmentKey));

        case 15:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function cancelAppointment(payload) {
  var appointmentKey, accountKey, roomKey, sendSMS, api, body, url, response;
  return _regenerator2.default.wrap(function cancelAppointment$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          appointmentKey = payload.appointmentKey, accountKey = payload.accountKey, roomKey = payload.roomKey, sendSMS = payload.sendSMS;
          api = new _webSso.AuthApi();
          body = [{
            ActionMaker: 'Doctor',
            AccountKey: accountKey,
            RoomKey: roomKey,
            ReservationKey: appointmentKey,
            CloseReasonId: 12,
            SendCancellationMessage: sendSMS
          }];
          url = _webUtils.Urls.cancelAppointment;
          _context12.next = 6;
          return api.post(url, body);

        case 6:
          response = _context12.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context12.next = 12;
            break;
          }

          _context12.next = 10;
          return (0, _effects.put)((0, _appointments.cancelSuccess)(appointmentKey));

        case 10:
          _context12.next = 14;
          break;

        case 12:
          _context12.next = 14;
          return (0, _effects.put)((0, _appointments.cancelFail)(appointmentKey));

        case 14:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function addPrescription(payload) {
  var accountToken, Headers, addPrescriptionAPI, body, response;
  return _regenerator2.default.wrap(function addPrescription$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          addPrescriptionAPI = new _webUtils.API();
          body = {
            prescriptionImages: payload.prescriptionImages,
            prescriptionTypeId: payload.prescriptionTypeId,
            operationKey: payload.reservationKey,
            prescriptionOwnerKey: payload.accountKey,
            actionMakerTypeId: 1,
            InsuranceKey: payload.insuranceKey,
            InsuranceCardKey: payload.insuranceCardKey
          };
          _context13.next = 6;
          return addPrescriptionAPI.post(_webUtils.Urls.prescription.addPrescription, body, Headers);

        case 6:
          response = _context13.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context13.next = 12;
            break;
          }

          _context13.next = 10;
          return (0, _effects.put)((0, _appointments.addPrescriptionSuccess)(payload.reservationKey, payload.prescriptionImages.length, payload.successMassage));

        case 10:
          _context13.next = 14;
          break;

        case 12:
          _context13.next = 14;
          return (0, _effects.put)((0, _appointments.addPrescriptionFail)(payload.errorMassage));

        case 14:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function getPatientNationalId(payload) {
  var Headers, getNationalIdApi, getNationalIdApiResponse;
  return _regenerator2.default.wrap(function getPatientNationalId$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          Headers = [{
            key: 'x-vzt-Component',
            value: 'AccWeb'
          }, {
            key: 'ServiceKey',
            value: 'nationalids'
          }];
          getNationalIdApi = new _webUtils.API();
          _context14.next = 4;
          return getNationalIdApi.get(process.env.REACT_APP_CONTENT_UPLOADER + '/api/contentuploader/' + payload.reservationKey, Headers);

        case 4:
          getNationalIdApiResponse = _context14.sent;

          if (!_webUtils.STATUS.isSuccess(getNationalIdApiResponse.status)) {
            _context14.next = 10;
            break;
          }

          _context14.next = 8;
          return (0, _effects.put)((0, _appointments.fetchNationalIdSuccess)(getNationalIdApiResponse.data));

        case 8:
          _context14.next = 12;
          break;

        case 10:
          _context14.next = 12;
          return (0, _effects.put)((0, _appointments.fetchNationalIdFail)());

        case 12:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function getPatientInsuranceCard(payload) {
  var accountToken, Headers, getPatientcardDetails, getPatientcardDetailsApiResponse;
  return _regenerator2.default.wrap(function getPatientInsuranceCard$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }, {
            key: 'Language',
            value: 'en-EG'
          }];
          getPatientcardDetails = new _webUtils.API();
          _context15.next = 5;
          return getPatientcardDetails.get(process.env.REACT_APP_ACCOUNT_MANAGEMENT_GATEWAY + '/patients-ms-api/api/patientinsurances?id=' + payload.cardKey, Headers);

        case 5:
          getPatientcardDetailsApiResponse = _context15.sent;

          if (!_webUtils.STATUS.isSuccess(getPatientcardDetailsApiResponse.status)) {
            _context15.next = 11;
            break;
          }

          _context15.next = 9;
          return (0, _effects.put)((0, _appointments.fetchPatientInsuranceCardSuccess)(getPatientcardDetailsApiResponse.data));

        case 9:
          _context15.next = 13;
          break;

        case 11:
          _context15.next = 13;
          return (0, _effects.put)((0, _appointments.fetchPatientInsuranceCardFail)());

        case 13:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function uploadNationalIdImg(payload) {
  var url, contentFormData, oldFiles, response;
  return _regenerator2.default.wrap(function uploadNationalIdImg$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          url = process.env.REACT_APP_CONTENT_UPLOADER + '/api/ContentUploader';
          contentFormData = new FormData();

          contentFormData.append('OperationKey', payload.data.reservationKey);
          contentFormData.append('Files', payload.data.nationalIdImg);
          // eslint-disable-next-line no-unused-vars
          oldFiles = payload.data.nationalId.patientNationalId && payload.data.nationalId.patientNationalId.attachments && payload.data.nationalId.patientNationalId.attachments.forEach(function (item) {
            contentFormData.append('OldFilesUrl', item.url);
          });
          _context16.next = 7;
          return (0, _effects.call)(fetch, url, {
            method: 'post',
            headers: {
              'x-vzt-Component': 'AccWeb',
              ServiceKey: 'nationalids'
            },
            body: contentFormData
          });

        case 7:
          response = _context16.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context16.next = 13;
            break;
          }

          _context16.next = 11;
          return (0, _effects.put)((0, _appointments.uploadNationalIdSuccess)(response.data));

        case 11:
          _context16.next = 15;
          break;

        case 13:
          _context16.next = 15;
          return (0, _effects.put)((0, _appointments.uploadNationalIdFail)());

        case 15:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function getPatientApprovalLetter(payload) {
  var Headers, getApprovalLetterApi, getApprovalLetterApiResponse;
  return _regenerator2.default.wrap(function getPatientApprovalLetter$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          Headers = [{
            key: 'x-vzt-Component',
            value: 'AccWeb'
          }, {
            key: 'ServiceKey',
            value: 'approvalletters'
          }];
          getApprovalLetterApi = new _webUtils.API();
          _context17.next = 4;
          return getApprovalLetterApi.get(process.env.REACT_APP_CONTENT_UPLOADER + '/api/contentuploader/' + payload.reservationKey, Headers);

        case 4:
          getApprovalLetterApiResponse = _context17.sent;

          if (!_webUtils.STATUS.isSuccess(getApprovalLetterApiResponse.status)) {
            _context17.next = 10;
            break;
          }

          _context17.next = 8;
          return (0, _effects.put)((0, _appointments.fetchApprovalLetterSuccess)(getApprovalLetterApiResponse.data));

        case 8:
          _context17.next = 12;
          break;

        case 10:
          _context17.next = 12;
          return (0, _effects.put)((0, _appointments.fetchApprovalLetterFail)());

        case 12:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function uploadApprovalLetter(payload) {
  var _payload$data, reservationKey, approvalLetterFile, approvalLetter, mixpanel, doctorName, InsuranceProviderName, mainSpecialty, areaName, url, contentFormData, oldFiles, response;

  return _regenerator2.default.wrap(function uploadApprovalLetter$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _payload$data = payload.data, reservationKey = _payload$data.reservationKey, approvalLetterFile = _payload$data.approvalLetterFile, approvalLetter = _payload$data.approvalLetter, mixpanel = _payload$data.mixpanel, doctorName = _payload$data.doctorName, InsuranceProviderName = _payload$data.InsuranceProviderName, mainSpecialty = _payload$data.mainSpecialty, areaName = _payload$data.areaName;
          url = process.env.REACT_APP_CONTENT_UPLOADER + '/api/ContentUploader';
          contentFormData = new FormData();

          contentFormData.append('OperationKey', reservationKey);
          contentFormData.append('Files', approvalLetterFile);
          // eslint-disable-next-line no-unused-vars
          oldFiles = approvalLetter.patientApprovalLetter && approvalLetter.patientApprovalLetter.attachments && approvalLetter.patientApprovalLetter.attachments.forEach(function (item) {
            contentFormData.append('OldFilesUrl', item.url);
          });
          _context18.next = 8;
          return (0, _effects.call)(fetch, url, {
            method: 'post',
            headers: {
              'x-vzt-Component': 'AccWeb',
              ServiceKey: 'approvalletters'
            },
            body: contentFormData
          });

        case 8:
          response = _context18.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context18.next = 14;
            break;
          }

          _context18.next = 12;
          return (0, _effects.put)((0, _appointments.uploadApprovalLetterSuccess)(response.data));

        case 12:
          _context18.next = 16;
          break;

        case 14:
          _context18.next = 16;
          return (0, _effects.put)((0, _appointments.uploadApprovalLetterFail)());

        case 16:
          mixpanel.track('Submit approval letter', {
            'Selected insurance': InsuranceProviderName,
            'File added': _webUtils.STATUS.isSuccess(response.status) ? 'Y' : 'N',
            'Type of file uploaded': approvalLetterFile.type === 'application/pdf' ? 'pdf' : 'image',
            'Reservation key': reservationKey,
            'Doctor name': doctorName,
            'Doctor Specialty': mainSpecialty,
            'area value': areaName
          });

        case 17:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function sagaAddVitals(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function sagaAddVitals$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context19.next = 5;
          return api.post(_webUtils.Urls.addVitals + '/' + action.payload.reservationKey + '/vital', action.payload.vitalsObj, header);

        case 5:
          response = _context19.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context19.next = 11;
            break;
          }

          _context19.next = 9;
          return (0, _effects.put)((0, _appointments.addVitalsSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context19.next = 13;
          break;

        case 11:
          _context19.next = 13;
          return (0, _effects.put)((0, _appointments.addVitalsFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function sagaUpdateVitals(action) {
  var api, authToken, header, response;
  return _regenerator2.default.wrap(function sagaUpdateVitals$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context20.next = 5;
          return api.put(_webUtils.Urls.updateVitals + '/' + action.payload.vitalKey, action.payload.vitalsObj, header);

        case 5:
          response = _context20.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context20.next = 11;
            break;
          }

          _context20.next = 9;
          return (0, _effects.put)((0, _appointments.updateVitalsSuccess)(_extends({}, response.response, action.payload)));

        case 9:
          _context20.next = 13;
          break;

        case 11:
          _context20.next = 13;
          return (0, _effects.put)((0, _appointments.updateVitalsFail)(_extends({}, response)));

        case 13:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function appointmentsSaga() {
  return _regenerator2.default.wrap(function appointmentsSaga$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.FETCH.LOAD, fetchAppointments);

        case 2:
          _context21.next = 4;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.FETCH_UPDATES.LOAD, fetchAppointmentsUpdates);

        case 4:
          _context21.next = 6;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.CREATE.LOAD, addAppointment);

        case 6:
          _context21.next = 8;
          return (0, _effects.takeEvery)(_appointments.APPOINTMENTS.MARK_AS_NO_SHOW.LOAD, markAsNoShow);

        case 8:
          _context21.next = 10;
          return (0, _effects.takeEvery)(_appointments.APPOINTMENTS.CHECK_IN.LOAD, checkInAppointment);

        case 10:
          _context21.next = 12;
          return (0, _effects.takeEvery)(_appointments.APPOINTMENTS.COMPLETE.LOAD, completeAppointment);

        case 12:
          _context21.next = 14;
          return (0, _effects.takeEvery)(_appointments.APPOINTMENTS.CANCEL.LOAD, cancelAppointment);

        case 14:
          _context21.next = 16;
          return (0, _effects.takeEvery)(_appointments.APPOINTMENTS.MARK_AS_INSURED.LOAD, markAsInsured);

        case 16:
          _context21.next = 18;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.ADD_PRESCRIPTION.LOAD, addPrescription);

        case 18:
          _context21.next = 20;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.ADD_APPOINTMENT.SUBMIT, upsertAppointment);

        case 20:
          _context21.next = 22;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.EDIT_APPOINTMENT.SUBMIT, upsertEditAppointment);

        case 22:
          _context21.next = 24;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.NATIONAL_ID.LOAD, getPatientNationalId);

        case 24:
          _context21.next = 26;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.GET_APPOINTMENT_INVOICE.LOAD, getAppointmentInvoice);

        case 26:
          _context21.next = 28;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.INSURANCE_CARD.LOAD, getPatientInsuranceCard);

        case 28:
          _context21.next = 30;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.UPLOAD_NATIONAL_ID.LOAD, uploadNationalIdImg);

        case 30:
          _context21.next = 32;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.FETCH_COUNT_RESERVATION.LOAD, getReservationCount);

        case 32:
          _context21.next = 34;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.APPROVAL_LETTER.LOAD, getPatientApprovalLetter);

        case 34:
          _context21.next = 36;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.UPLOAD_APPROVAL_LETTER.LOAD, uploadApprovalLetter);

        case 36:
          _context21.next = 38;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.ADD_VITALS.SUBMIT, sagaAddVitals);

        case 38:
          _context21.next = 40;
          return (0, _effects.takeLatest)(_appointments.APPOINTMENTS.UPDATE_VITALS.SUBMIT, sagaUpdateVitals);

        case 40:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

exports.default = appointmentsSaga;
module.exports = exports['default'];